import React from 'react';
import { get } from 'lodash';

import styles from './ProjectDetailsFieldVisibillityFIeld.module.scss';
import { ProjectDetailsField } from 'nekst-api';
import { useShowContext } from 'ui-builder';

export default function ProjectDetailsFieldVisibilityField(
  props: {
    source: string,
  },
) {
  const showContext = useShowContext<ProjectDetailsField>();

  const fieldValue = !!get(showContext.data, props.source);

  return (
    <span
      className={`${styles.field} ${fieldValue ? styles.hidden : styles.visible}`}
      title={fieldValue ? 'Hidden' : 'Visible'}
    >
      &nbsp;
    </span>
  );
}
